/*
 * @Author: lvbl
 * @Date: 2021-05-21 16:09:59
 * @LastEditTime: 2022-02-10 10:50:17
 * @LastEditors: Please set LastEditors
 * @Description: 为动态路由设计提取
 * @FilePath: \NavDemo\src\router\index.js
 */
import routes from './router.config.js';
import others from './other.config.js';
import edits from './edit.config.js';

//将其他数据塞入router中
others.forEach(other => {
    routes[0].children.push(other)
})
export const bj = [routes, edits];
export const routerMapDeal = (routes) => {
    return routes.reduce((routeMap, targetRoute) => {
        routeMap.push(dealRouteObj(targetRoute));
        return routeMap;
    }, []);
};
export const dealRouteObj = ({ children, component, path, ...args }) => {
    return Object.assign({
        path: `/:station${path}`,
        component: () =>
            import (`@/views/nportal/views/${component}`),
        children: children ? routerMapDeal(children) : []
    }, args);
};